import React from 'react';
var Divider = function () { return React.createElement("span", { className: "syl-toolbar-divider" }); };
export { Divider };
//# sourceMappingURL=divider.js.map